export default __webpack_public_path__ + "static/media/Icon_Filter_ckc.f045682a.svg";